import React from 'react'
import styles from './ContentButton.module.css'

export default function ContentButton({ icon, name, onClick, style={} }) {
    return (
        <div style={style} className={styles.ContentButton} onClick={onClick}>{icon}<p>{name}</p></div>
    )
}
